export const EACH_PERIOD = '1'
export const EACH_MAIN_PERIOD = '2'
export const SELECTED_PERIODS = '3'

export const PRODUCT_PERIODIC_BILLING_TYPE = '1'
export const PRODUCT_ACTIVITY_BASED_BILLING_TYPE = '2'
